import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { ReactiveFormsModule, Validators, NonNullableFormBuilder } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { InfoBoxComponent } from '../../components/utility/info-box/info-box.component';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { HttpService } from '../../services/http.service';
import { UserRegisterDataDTO } from '../../classes/user-account.dto';
import { UpdatePreferencesDTO, RedeemCodeDTO } from '../../classes/api-dto';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DataService } from '../../services/data.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule, DatePipe } from '@angular/common';
import { StorageService } from '../../services/storage.service';
import { AuthService } from '../../services/auth.service';
import { GtmService } from '../../services/gtm.service';
import { ConfigService } from '../../services/env-config.service';
import { FiscalCodeService } from '../../services/fiscal-code.service';

@Component({
  selector: 'app-activation',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NzGridModule,
    TranslateModule,
    NzFlexModule,
    NzTypographyModule,
    NzButtonModule,
    NzDividerModule,
    NzIconModule,
    NzImageModule,
    NzFormModule,
    NzInputModule,
    NzSpaceModule,
    NzModalModule,
    NzStepsModule,
    NzSelectModule,
    FormsModule,
    NzRadioModule,
    RouterLink,
    CommonModule,
  ],
  templateUrl: './activation.component.html',
  styleUrl: './activation.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ActivationComponent {
  current = 0;
  isVisibleMiddle = false;
  individualId: string = '';
  countries = new Array();
  districts = new Array();
  cities = new Array();
  isPhonePortrait = false;
  companyId?: string;
  birthDate: any;
  alreadyExists: boolean = false;
  userIsRegistered: boolean = false;
  disabledMFA?: boolean;
  modalContentKey: string = 'activation.modal.content';

  constructor(
    private fb: NonNullableFormBuilder,
    private router: Router,
    private httpService: HttpService,
    private responsive: BreakpointObserver,
    private dataService: DataService,
    private toastr: ToastrService,
    private storageService: StorageService,
    private authService: AuthService,
    private translate: TranslateService,
    private gtmService: GtmService,
    private configService: ConfigService,
    private fiscalCodeService: FiscalCodeService
  ) {}

  radioValue = '';

  validateForm = this.fb.group({
    code: this.fb.control('', [Validators.required]),
    phoneNumber: this.fb.control('', [Validators.required, Validators.pattern(/^(?:\+?[0-9]{8,})$/)]),
    nation: this.fb.control('', [Validators.required]),
    houseNumber: this.fb.control('', [Validators.required]),
    province: this.fb.control('', [Validators.required]),
    cap: this.fb.control('', [Validators.required]),
    city: this.fb.control('', [Validators.required]),
    address: this.fb.control('', [Validators.required]),
    email: this.fb.control('', [Validators.required, Validators.email]),
    fiscalCode: this.fb.control('', [Validators.required]),
    name: this.fb.control('', [Validators.required]),
    surname: this.fb.control('', [Validators.required]),
    radio1: this.fb.control('', [Validators.required]),
    radio2: this.fb.control('', [Validators.required]),
    radio3: this.fb.control('', [Validators.required]),
    radio4: this.fb.control('', [Validators.required]),
    radioTerms: this.fb.control('', [Validators.required]),
  });

  public ngOnInit(): void {
    this.dataService.companyId$.subscribe((companyId) => {
      this.companyId = companyId;
    });
     this.configService.getConfig().subscribe((res: any) =>{
      this.disabledMFA  = res?.disabledMFA;
    });
    this.responsive.observe(Breakpoints.HandsetPortrait).subscribe((result) => {
      this.isPhonePortrait = false;
      if (result.matches) {
        this.isPhonePortrait = true;
      }
    });
  }

  next(index: any): void {
    console.log('current:', this.current)
    switch (index) {
      case 0: {
        if (this.validateForm.get('code')?.valid) {
          let code: string = this.validateForm.get('code')?.value!;
          this.httpService.checkcodevalidity(code).subscribe({
            next: (response) => {
              if (response.codeIsValid) {
                if (response.companyId) {
                  // cambio companyid indicata nella risposta
                  this.dataService.setCompanyId(response.companyId);
                }
                this.current += 1;
                this.gtmService.pushActivationCodeEvent('step1_activation_code', this.userIsRegistered);
                this.gtmService.pushVirtualPage('Activation Code', '/step1_activation_code')
              } else {
                if (this.companyId === '45C41017') {
                  this.toastr.error(this.translate.instant('toastr.error.codeErrorFasdac'));
                } else {
                  this.toastr.error(this.translate.instant('toastr.error.codeError'));
                }
              }
            },
            error: (error) => {
              console.error(error);
              this.toastr.error(this.translate.instant('toastr.error.activationCodeError'));
            },
          });
        } else {
          this.validateForm.get('code')?.markAsDirty();
          this.validateForm.get('code')?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
      case 1: {
          const emailControl = this.validateForm.get('email');
          const fiscalCodeControl = this.validateForm.get('fiscalCode');
          if (emailControl?.valid && fiscalCodeControl?.valid) {
            const fiscalCode: string = fiscalCodeControl.value!;
            const email: string = emailControl.value!;
            const isValidCF = this.fiscalCodeService.isFiscalCodeValid(fiscalCode);
            if (!isValidCF) {
              this.toastr.error(this.translate.instant('toastr.error.invalidFiscalCode'));
              return;
            }
            let datiCF;
            try {
              datiCF = this.fiscalCodeService.extractData(fiscalCode);
            } catch (err) {
              this.toastr.error(this.translate.instant('toastr.error.invalidFiscalCode'));
              return;
            }
            const birth = datiCF.birthday;
            const day = birth.getDate().toString().padStart(2, '0');
            const month = (birth.getMonth() + 1).toString().padStart(2, '0');
            const year = birth.getFullYear().toString();
            this.birthDate = `${year}-${month}-${day}`;
            this.httpService.isPolicyHolder(email, fiscalCode).subscribe({
            next: (res) => {
            if (res.isPolicyHolder && res.isFirstTimeCodeActivation) {
              this.router.navigate(['login']).then();
              return;
            }
            if (!res.isPolicyHolder) {
              if (this.companyId === '45C41017') {
                this.toastr.error(
                  this.translate.instant('toastr.error.nominativeError')
                );
              } else {
                this.toastr.error(
                  this.translate.instant('toastr.error.insertError')
                );
              }
              return;
            }
            this.httpService.getIndividualId(email, fiscalCode).subscribe({
              next: (v2) => {
                this.userIsRegistered =
                  res.isPolicyHolder && !res.isFirstTimeCodeActivation;
                if (!v2.individualId) {
                  this.current += 1;
                  this.gtmService.pushActivationCodeEvent(
                    'step2_information',
                    this.userIsRegistered
                  );
                  this.gtmService.pushVirtualPage('Informazioni', '/step2_information')
                } else {
                  this.individualId = v2.individualId;
                  this.current += 4;
                  this.alreadyExists = true;
                }
              },
              error: () => this.showModalMiddle(),
            });
          },
          error: () => this.showModalMiddle(),
        });
      } else {
        emailControl?.markAsDirty();
        emailControl?.updateValueAndValidity({ onlySelf: true });
        fiscalCodeControl?.markAsDirty();
        fiscalCodeControl?.updateValueAndValidity({ onlySelf: true });
      }
      break;
      }
      case 2: {
        if (this.validateForm.get('name')?.valid && this.validateForm.get('surname')?.valid && this.validateForm.get('phoneNumber')?.valid) {
          this.httpService.getCountries().subscribe((res: any) => {
            if (res) {
              this.countries = res;
              this.current += 1;
              this.gtmService.pushActivationCodeEvent('step3_contact_details', this.userIsRegistered);
              this.gtmService.pushVirtualPage('Contact details', '/step3_contact_details')
            }
          });
        } else {
          this.validateForm.get('name')?.markAsDirty();
          this.validateForm.get('name')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('surname')?.markAsDirty();
          this.validateForm.get('surname')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('phoneNumber')?.markAsDirty();
          this.validateForm.get('phoneNumber')?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
      case 3: {
        if (
          this.validateForm.get('nation')?.valid &&
          this.validateForm.get('province')?.valid &&
          this.validateForm.get('city')?.valid &&
          this.validateForm.get('cap')?.valid &&
          this.validateForm.get('address')?.valid &&
          this.validateForm.get('houseNumber')?.valid
        ) {
          this.current += 1;
          this.gtmService.pushActivationCodeEvent('step4_residence', this.userIsRegistered);
          this.gtmService.pushVirtualPage('Residence', '/step4_residence')
        } else {
          this.validateForm.get('nation')?.markAsDirty();
          this.validateForm.get('nation')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('province')?.markAsDirty();
          this.validateForm.get('province')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('city')?.markAsDirty();
          this.validateForm.get('city')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('cap')?.markAsDirty();
          this.validateForm.get('cap')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('address')?.markAsDirty();
          this.validateForm.get('address')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('houseNumber')?.markAsDirty();
          this.validateForm.get('houseNumber')?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
      case 4: {
        if (this.validateForm.get('radio1')?.valid && this.validateForm.get('radio2')?.valid && this.validateForm.get('radio3')?.valid && this.validateForm.get('radio4')?.valid) {
          let userData = new UserRegisterDataDTO();
          userData.name = this.validateForm.get('name')?.value!;
          userData.surname = this.validateForm.get('surname')?.value!;
          userData.taxId = this.validateForm.get('fiscalCode')?.value!;
          userData.city = this.cities.find((res) => res.code === this.validateForm.get('city')?.value!);
          userData.address = this.validateForm.get('address')?.value!;
          userData.postalCode = this.validateForm.get('cap')?.value!;
          userData.userName = this.validateForm.get('email')?.value!;
          userData.email = this.validateForm.get('email')?.value!;
          userData.phone = this.validateForm.get('phoneNumber')?.value!;
          if (this.birthDate) {
            userData.birthDate = this.birthDate;
          } else {
            const birthdateValue = this.validateForm.get('birthdate')?.value;
            if (typeof birthdateValue === 'string') {
              const [day, month, yearWithTime] = (birthdateValue as string).split('/');
              const [year] = yearWithTime.split(' ');
              userData.birthDate = `${year}-${month}-${day}`;
            } else {
              console.warn('Invalid birthdate date format or value not found');
              userData.birthDate = '';
            }
          }
          //userData.fbUserId = //get from configuration;
          //userData.googleUserId = //get from configuration;
          userData.privacy_eai_iccs = this.validateForm.get('radio1')?.value! == 'true' ? true : false;
          userData.privacy_eai_profile = this.validateForm.get('radio2')?.value! == 'true' ? true : false;
          userData.privacy_vai_iccs = this.validateForm.get('radio3')?.value! == 'true' ? true : false;
          userData.privacy_vai_profile = this.validateForm.get('radio4')?.value! == 'true' ? true : false;
          userData.companyId = this.companyId!;
          userData.registerWithFacebook = false;
          userData.registerWithGoogle = false;

          this.httpService.registerBP(userData).subscribe({
            next: (v) => {
              console.log(v);
              let updatePreferences = new UpdatePreferencesDTO();
              updatePreferences.botAllowed = v.botAllowed;
              updatePreferences.careManagerServiceAllowed = v.careManagerServiceAllowed;
              updatePreferences.consultServiceAllowed = v.consultServiceAllowed;
              updatePreferences.language = v.language;
              updatePreferences.multiLanguageAllowed = v.multiLanguageAllowed;
              updatePreferences.personalServiceAllowed = v.personalServiceAllowed;
              updatePreferences.symptomsServiceAllowed = v.symptomsServiceAllowed;
              updatePreferences.travelServiceAllowed = v.travelServiceAllowed;
              this.individualId = v.individualId;
              updatePreferences.individualId = this.individualId;
              this.httpService.updatePreferences(updatePreferences).subscribe({
                next: (v1) => {
                  this.current += 1;
                  this.gtmService.pushActivationCodeEvent('step5_privacy', this.userIsRegistered);
                  this.gtmService.pushVirtualPage('Privacy', '/step5_privacy');
                  this.gtmService.pushVirtualPage('Terms of use', '/step6_terms_of_use')
                  this.gtmService.pushActivationCodeEvent('activation_code_success', this.userIsRegistered);
                },
                error: (e1) => this.showModalMiddle(),
              });
            },
            error: (e) => this.showModalMiddle(),
          });
        } else {
          this.validateForm.get('radio1')?.markAsDirty();
          this.validateForm.get('radio1')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('radio2')?.markAsDirty();
          this.validateForm.get('radio2')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('radio3')?.markAsDirty();
          this.validateForm.get('radio3')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('radio4')?.markAsDirty();
          this.validateForm.get('radio4')?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
      case 5: {
        if (this.validateForm.get('radioTerms')?.valid) {
          this.httpService.isActivateUser(this.individualId!).subscribe({
            next: (v) => {
              let redeemCode: RedeemCodeDTO = {
                activationCode: this.validateForm.get('code')?.value!,
                companyId: this.companyId!,
                individualId: this.individualId,
              };
              this.httpService.redeemCode(redeemCode).subscribe({
                next: (v1) => {
                  if(this.disabledMFA ?? true){
                    this.authService.checkLoginStatus(v1, 'activation');
                    this.gtmService.pushLoginEvent('Codice');
                  } else {
                    this.router.navigate(['/login']);
                  }
                },
                error: (e) => {
                  if(e?.error?.errorCode === 'UserNotEligible'){
                    this.modalContentKey = 'activation.modal.userNotEligible';
                  } else {
                    this.modalContentKey = 'activation.modal.content';
                  }
                  this.showModalMiddle();
                }
              });
            },
            error: (e) => this.showModalMiddle(),
          });
        } else {
          this.validateForm.get('radioTerms')?.markAsDirty();
          this.validateForm.get('radioTerms')?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
      default: {
        this.current += 1;
      }
    }
  }

  back(): void {
    if (this.current === 2) {
      this.validateForm.get('email')?.enable();
    }
    this.current -= 1;
  }

  showModalMiddle(): void {
    this.isVisibleMiddle = true;
  }

  handleOkMiddle(): void {
    this.isVisibleMiddle = false;
  }

  fillDistricts(): void {
    if (this.validateForm.get('nation')?.value!) {
      this.httpService.getDistrict(this.validateForm.get('nation')?.value!).subscribe({
        next: (v) => {
          this.validateForm.get('district')?.value ? this.validateForm.get('province')?.patchValue('') : '';
          this.validateForm.get('city')?.value ? this.validateForm.get('city')?.patchValue('') : '';
          this.districts = v;
        },
        error: (e) => {
          this.validateForm.get('nation')?.patchValue('');
          this.validateForm.get('province')?.value ? this.validateForm.get('province')?.patchValue('') : '';
          this.validateForm.get('city')?.value ? this.validateForm.get('city')?.patchValue('') : '';
          this.districts = [];
          this.cities = [];
          this.showModalMiddle();
        },
      });
    }
  }

  fillCities(): void {
    if (this.validateForm.get('province')?.value!) {
      this.httpService.getProvince(this.validateForm.get('province')?.value!).subscribe({
        next: (v) => {
          this.cities = v;
          this.validateForm.get('city')?.value ? this.validateForm.get('city')?.patchValue('') : '';
        },
        error: (e) => {
          this.validateForm.get('province')?.patchValue('');
          this.validateForm.get('city')?.value ? this.validateForm.get('city')?.patchValue('') : '';
          this.cities = [];
          this.showModalMiddle();
        },
      });
    }
  }

  goToLink() {
    window.open('https://assets.apps.redion.it/Documents/informativa-privacy-MyClinic.pdf', '_blank', 'noopener');
  }

  //TODO: CHECK IF THAT WORKS
  public checkDisabledState(current: number): boolean {
    switch (current) {
      case 0:
        return this.validateForm.get('code') ? this.validateForm.get('code')!.invalid : true;
      case 1:
        return this.validateForm.get('email') && this.validateForm.get('fiscalCode')
          ? this.validateForm.get('email')!.invalid || this.validateForm.get('fiscalCode')!.invalid
          : true;
      case 2:
        return this.validateForm.get('name') && this.validateForm.get('surname') && this.validateForm.get('phoneNumber')
          ? this.validateForm.get('name')!.invalid || this.validateForm.get('surname')!.invalid || this.validateForm.get('phoneNumber')!.invalid
          : true;
      case 3:
        return this.validateForm.get('nation') &&
          this.validateForm.get('province') &&
          this.validateForm.get('city') &&
          this.validateForm.get('cap') &&
          this.validateForm.get('address') &&
          this.validateForm.get('houseNumber')
          ? this.validateForm.get('nation')!.invalid ||
              this.validateForm.get('province')!.invalid ||
              this.validateForm.get('city')!.invalid ||
              this.validateForm.get('cap')!.invalid ||
              this.validateForm.get('address')!.invalid ||
              this.validateForm.get('houseNumber')!.invalid
          : true;
      case 4:
        return this.validateForm.get('radio1') && this.validateForm.get('radio2') && this.validateForm.get('radio3') && this.validateForm.get('radio4')
          ? this.validateForm.get('radio1')!.invalid ||
              this.validateForm.get('radio2')!.invalid ||
              this.validateForm.get('radio3')!.invalid ||
              this.validateForm.get('radio4')!.invalid
          : true;
      case 5:
        return this.validateForm.get('radioTerms') ? this.validateForm.get('radioTerms')!.invalid : true;
      default:
        return true;
    }
  }
}
